// Malayalam: mobile tab bar, More sheet, page names, sign-in page and NFC button. Keyed by the English source text; {name} placeholders stay as-is.
export default {
  " and ": " ",
  ".": " അംഗീകരിക്കുന്നു.",
  "By signing in, you agree to AssetOS ": "സൈൻ ഇൻ ചെയ്യുന്നതിലൂടെ, നിങ്ങൾ AssetOS-ന്റെ ",
  "Terms of Service": "സേവന നിബന്ധനകളും",
  "Privacy Policy": "സ്വകാര്യതാ നയവും",
  "API & Webhooks": "API-യും വെബ്ഹുക്കുകളും",
  "Account Subscription & Plans": "അക്കൗണ്ട് സബ്സ്ക്രിപ്ഷനും പ്ലാനുകളും",
  "All {app} Modules": "{app}-ലെ എല്ലാ മൊഡ്യൂളുകളും",
  "Allow NFC for this site to read tags.": "ടാഗുകൾ വായിക്കാൻ ഈ സൈറ്റിന് NFC അനുവദിക്കുക.",
  "Asset Custody & Movements": "ആസ്തി കസ്റ്റഡിയും നീക്കങ്ങളും",
  "Asset Disposals & Write-Offs": "ആസ്തി ഡിസ്പോസലും എഴുതിത്തള്ളലും",
  "Asset Lookup": "ആസ്തി തിരയൽ",
  "Asset Quick View": "ആസ്തി ദ്രുത കാഴ്ച",
  "Asset Valuation & Analytics Dashboard": "ആസ്തി മൂല്യനിർണ്ണയ, അനലിറ്റിക്സ് ഡാഷ്ബോർഡ്",
  "Audit": "ഓഡിറ്റ്",
  "Audit Reconciliation Console": "ഓഡിറ്റ് പൊരുത്തപ്പെടുത്തൽ കൺസോൾ",
  "Banquet Event Kits": "ബാങ്ക്വറ്റ് ഇവന്റ് കിറ്റുകൾ",
  "Banquet Event Kits & Batch Reconciliation": "ബാങ്ക്വറ്റ് ഇവന്റ് കിറ്റുകളും ബാച്ച് പൊരുത്തപ്പെടുത്തലും",
  "Blind Counts & Variance Console": "ബ്ലൈൻഡ് കൗണ്ട്, വ്യത്യാസ കൺസോൾ",
  "Books": "ബുക്കുകൾ",
  "Camera Scan HUD": "ക്യാമറ സ്കാൻ",
  "Catalogue": "കാറ്റലോഗ്",
  "Connected Platforms": "ബന്ധിപ്പിച്ച പ്ലാറ്റ്ഫോമുകൾ",
  "Contents": "ഉള്ളടക്കം",
  "Corporate Email Address": "കോർപ്പറേറ്റ് ഇമെയിൽ വിലാസം",
  "Demo": "ഡെമോ",
  "Demo accounts — 1-click test sign-in": "ഡെമോ അക്കൗണ്ടുകൾ — ഒറ്റ ക്ലിക്ക് ടെസ്റ്റ് സൈൻ-ഇൻ",
  "Demo sign-in failed": "ഡെമോ സൈൻ-ഇൻ പരാജയപ്പെട്ടു",
  "Depreciation Runs & GL Schedules": "മൂല്യത്തകർച്ച റണ്ണുകളും GL ഷെഡ്യൂളുകളും",
  "Email or password is incorrect": "ഇമെയിൽ അല്ലെങ്കിൽ പാസ്‌വേഡ് തെറ്റാണ്",
  "Enter your work email first so we can find your organisation’s sign-in.": "നിങ്ങളുടെ സ്ഥാപനത്തിന്റെ സൈൻ-ഇൻ കണ്ടെത്താൻ ആദ്യം ജോലി ഇമെയിൽ നൽകുക.",
  "Enterprise Hospitality Fixed Asset Operating System": "എന്റർപ്രൈസ് ഹോസ്പിറ്റാലിറ്റി ഫിക്സഡ് അസറ്റ് ഓപ്പറേറ്റിംഗ് സിസ്റ്റം",
  "Event Kits": "ഇവന്റ് കിറ്റുകൾ",
  "Exception Queue": "എക്സെപ്ഷൻ ക്യൂ",
  "Exceptions": "എക്സെപ്ഷനുകൾ",
  "Field App": "ഫീൽഡ് ആപ്പ്",
  "First Scan": "ആദ്യ സ്കാൻ",
  "First Scan Walk Binding": "ആദ്യ സ്കാൻ വാക്ക് ബൈൻഡിംഗ്",
  "First-Scan Walk": "ആദ്യ-സ്കാൻ വാക്ക്",
  "Forgot Password": "പാസ്‌വേഡ് മറന്നു",
  "Forgot password?": "പാസ്‌വേഡ് മറന്നോ?",
  "Guest Loaners": "അതിഥി ലോണറുകൾ",
  "Guest Loaners & Overdue Tracker": "അതിഥി ലോണറുകളും കാലാവധി കഴിഞ്ഞവയുടെ ട്രാക്കറും",
  "Hold the tag to the phone…": "ടാഗ് ഫോണിനോട് ചേർത്തുപിടിക്കുക…",
  "How to get access": "ആക്സസ് എങ്ങനെ നേടാം",
  "IAS 16 cost model with USALI operating department allocation and automated Xero GL manual journals.": "USALI ഓപ്പറേറ്റിംഗ് വകുപ്പ് വിഹിതവും ഓട്ടോമേറ്റഡ് Xero GL മാനുവൽ ജേണലുകളുമുള്ള IAS 16 കോസ്റ്റ് മോഡൽ.",
  "Inwarding & Asset Tagging": "ഇൻവേർഡിംഗും ആസ്തി ടാഗിംഗും",
  "Integration Fabric Connectors": "ഇന്റഗ്രേഷൻ ഫാബ്രിക് കണക്ടറുകൾ",
  "Linen Laundry": "ലിനൻ ലോൺട്രി",
  "Loaners": "ലോണറുകൾ",
  "Maintenance Incident Logging": "അറ്റകുറ്റപ്പണി സംഭവം രേഖപ്പെടുത്തൽ",
  "Maintenance Incidents": "അറ്റകുറ്റപ്പണി സംഭവങ്ങൾ",
  "Maintenance incidents": "അറ്റകുറ്റപ്പണി സംഭവങ്ങൾ",
  "Maintenance incidents: {count} active": "അറ്റകുറ്റപ്പണി സംഭവങ്ങൾ: {count} സജീവം",
  "Mobile App Navigation": "മൊബൈൽ ആപ്പ് നാവിഗേഷൻ",
  "Mobile Physical Audits & Par Management": "മൊബൈൽ ഭൗതിക ഓഡിറ്റുകളും പാർ മാനേജ്മെന്റും",
  "NFC is switched off or not available on this phone.": "ഈ ഫോണിൽ NFC ഓഫാണ് അല്ലെങ്കിൽ ലഭ്യമല്ല.",
  "Need an account? ": "അക്കൗണ്ട് വേണോ? ",
  "OR": "അല്ലെങ്കിൽ",
  "Offline": "ഓഫ്‌ലൈൻ",
  "Offline-ready room audits, deterministic conflict resolution, and pooled inventory par replenishment.": "ഓഫ്‌ലൈനിലും റൂം ഓഡിറ്റുകൾ, വ്യക്തമായ കോൺഫ്ലിക്റ്റ് പരിഹാരം, പൂൾഡ് ഇൻവെന്ററി പാർ നികത്തൽ.",
  "Offline: actions are saved on this device and synced later": "ഓഫ്‌ലൈൻ: പ്രവർത്തനങ്ങൾ ഈ ഉപകരണത്തിൽ സേവ് ചെയ്ത് പിന്നീട് സിങ്ക് ചെയ്യും",
  "Opening Inventory": "ഓപ്പണിംഗ് ഇൻവെന്ററി",
  "Password": "പാസ്‌വേഡ്",
  "Password is required": "പാസ്‌വേഡ് ആവശ്യമാണ്",
  "Physical Audit Verification": "ഭൗതിക ഓഡിറ്റ് പരിശോധന",
  "Please enter a valid corporate email address": "ശരിയായ കോർപ്പറേറ്റ് ഇമെയിൽ വിലാസം നൽകുക",
  "Property & Location Registry": "പ്രോപ്പർട്ടി, സ്ഥല രജിസ്റ്റർ",
  "Quick View": "ദ്രുത കാഴ്ച",
  "Room Contents Sheet": "മുറിയിലെ സാധനങ്ങളുടെ ഷീറ്റ്",
  "Room Kit Templates & Stamping": "റൂം കിറ്റ് ടെംപ്ലേറ്റുകളും സ്റ്റാമ്പിംഗും",
  "Room Stamping & Opaque ULID Tags": "റൂം സ്റ്റാമ്പിംഗും ഒപേക് ULID ടാഗുകളും",
  "Sign In": "സൈൻ ഇൻ",
  "Sign In to Dashboard": "ഡാഷ്ബോർഡിലേക്ക് സൈൻ ഇൻ ചെയ്യുക",
  "Sign in to manage hotel property fixed assets and operations": "ഹോട്ടൽ പ്രോപ്പർട്ടിയുടെ ആസ്തികളും പ്രവർത്തനങ്ങളും കൈകാര്യം ചെയ്യാൻ സൈൻ ഇൻ ചെയ്യുക",
  "Sign in with your organisation": "നിങ്ങളുടെ സ്ഥാപനം വഴി സൈൻ ഇൻ ചെയ്യുക",
  "Sign-in with your organisation did not complete. Please try again or use your email and password.": "സ്ഥാപനം വഴിയുള്ള സൈൻ-ഇൻ പൂർത്തിയായില്ല. വീണ്ടും ശ്രമിക്കുക അല്ലെങ്കിൽ ഇമെയിലും പാസ്‌വേഡും ഉപയോഗിക്കുക.",
  "Sign-in with your organisation was cancelled.": "സ്ഥാപനം വഴിയുള്ള സൈൻ-ഇൻ റദ്ദാക്കി.",
  "Single IFRS Book & USALI Allocations": "ഒറ്റ IFRS ബുക്കും USALI വിഹിതങ്ങളും",
  "Single sign-on could not be started. Use your email and password.": "സിംഗിൾ സൈൻ-ഓൺ തുടങ്ങാനായില്ല. ഇമെയിലും പാസ്‌വേഡും ഉപയോഗിക്കുക.",
  "Standardized room kit blueprints with tamper-evident QR codes and 6-character short codes.": "കൃത്രിമം തിരിച്ചറിയുന്ന QR കോഡുകളും 6-അക്ഷര ഷോർട്ട് കോഡുകളുമുള്ള സ്റ്റാൻഡേർഡ് റൂം കിറ്റ് ബ്ലൂപ്രിന്റുകൾ.",
  "Stock": "സ്റ്റോക്ക്",
  "Stock & Par": "സ്റ്റോക്കും പാറും",
  "Stock Points & Par": "സ്റ്റോക്ക് പോയിന്റുകളും പാറും",
  "Stock Points & Par Management": "സ്റ്റോക്ക് പോയിന്റുകളും പാർ മാനേജ്മെന്റും",
  "Streamlined property onboarding, room-level asset stamping, physical audit walks, native repair records, and automated single-book IAS 16 depreciation.": "ലളിതമായ പ്രോപ്പർട്ടി ഓൺബോർഡിംഗ്, മുറി തലത്തിലുള്ള ആസ്തി സ്റ്റാമ്പിംഗ്, ഭൗതിക ഓഡിറ്റ് വാക്കുകൾ, റിപ്പയർ രേഖകൾ, ഓട്ടോമേറ്റഡ് ഒറ്റ-ബുക്ക് IAS 16 മൂല്യത്തകർച്ച.",
  "Sync": "സിങ്ക്",
  "Sync Status": "സിങ്ക് നില",
  "Tag Generation & Binding": "ടാഗ് നിർമ്മാണവും ബൈൻഡിംഗും",
  "Tag Generation & Binding Console": "ടാഗ് നിർമ്മാണ, ബൈൻഡിംഗ് കൺസോൾ",
  "Tag Studio": "ടാഗ് സ്റ്റുഡിയോ",
  "Tap NFC tag": "NFC ടാഗ് ടാപ്പ് ചെയ്യുക",
  "That sign-in attempt expired. Please try again.": "ആ സൈൻ-ഇൻ ശ്രമം കാലഹരണപ്പെട്ടു. വീണ്ടും ശ്രമിക്കുക.",
  "The tag could not be read. Hold the phone still against it and try again.": "ടാഗ് വായിക്കാനായില്ല. ഫോൺ അതിൽ അനങ്ങാതെ ചേർത്തുപിടിച്ച് വീണ്ടും ശ്രമിക്കുക.",
  "There is no AssetOS account for this email. Ask your administrator for an invitation.": "ഈ ഇമെയിലിന് AssetOS അക്കൗണ്ട് ഇല്ല. നിങ്ങളുടെ അഡ്മിനിസ്ട്രേറ്ററോട് ക്ഷണം ചോദിക്കുക.",
  "This account belongs to a different organisation. Use your email and password instead.": "ഈ അക്കൗണ്ട് മറ്റൊരു സ്ഥാപനത്തിന്റേതാണ്. പകരം ഇമെയിലും പാസ്‌വേഡും ഉപയോഗിക്കുക.",
  "This invitation has already been used. Sign in with your organisation again.": "ഈ ക്ഷണം ഇതിനകം ഉപയോഗിച്ചു. സ്ഥാപനം വഴി വീണ്ടും സൈൻ ഇൻ ചെയ്യുക.",
  "Toggle password visibility": "പാസ്‌വേഡ് കാണിക്കുക/മറയ്ക്കുക",
  "User Registration": "ഉപയോക്തൃ രജിസ്ട്രേഷൻ",
  "Uses your organisation’s sign-in. Only people your administrator has invited can get in.": "നിങ്ങളുടെ സ്ഥാപനത്തിന്റെ സൈൻ-ഇൻ ഉപയോഗിക്കുന്നു. അഡ്മിനിസ്ട്രേറ്റർ ക്ഷണിച്ചവർക്ക് മാത്രമേ പ്രവേശിക്കാനാകൂ.",
  "Welcome back": "വീണ്ടും സ്വാഗതം",
  "Work Orders & Repair Management": "വർക്ക് ഓർഡറുകളും റിപ്പയർ മാനേജ്മെന്റും",
  "Your organisation has not verified this email address.": "നിങ്ങളുടെ സ്ഥാപനം ഈ ഇമെയിൽ വിലാസം സ്ഥിരീകരിച്ചിട്ടില്ല.",
  "Your organisation is not set up for single sign-on. Use your email and password.": "നിങ്ങളുടെ സ്ഥാപനം സിംഗിൾ സൈൻ-ഓണിനായി സജ്ജമാക്കിയിട്ടില്ല. ഇമെയിലും പാസ്‌വേഡും ഉപയോഗിക്കുക.",
  "field screens": "ഫീൽഡ് സ്ക്രീനുകൾ",
  "{count} waiting to sync": "{count} സിങ്കിനായി കാത്തിരിക്കുന്നു",
};
